import { BaseModel } from "@blue-chip/core";

export default class Commodity extends BaseModel {}
